import React from 'react';
import { Icon } from '../icons';

/**
 * Spinner — design-system loading indicator.
 * A rotating Loader2 glyph using currentColor. Size in px.
 */
const Spinner = ({ size = 16, className = '', ...rest }) => (
  <Icon.Spinner size={size} className={`ps-spinner ${className}`.trim()} {...rest} />
);

export default Spinner;
